import React, { Component } from 'react';

import _ from 'lodash';
import Sidebar from "react-sidebar";

import LogoHorizontal from '../../../assets/images/logo-horizontal.png';
import Message from '../../../common/components/message/message';
import { ErrorModal } from '../../../common/components/ui/modals';

import MenuSystem from './menu-system';

export default class ModuleSystem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sidebarOpen: false,
            visible: false
        };
        this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    }
    
    onSetSidebarOpen(open) {
        this.setState({ sidebarOpen: open });
    }

    toggleModal = (show=null) => {
        if(!_.isNull(show)) {
            this.setState({
                visible: show
            });
        } else {
            this.setState({
                visible: !this.state.visible,
            })
        }
    }
    
    render() {
        return (
            <div className="system">
                <Sidebar
                    sidebar={<MenuSystem togglMenu={this.onSetSidebarOpen} toggleModal={this.toggleModal} />}
                    open={this.state.sidebarOpen}
                    onSetOpen={this.onSetSidebarOpen}
                    styles={{
                        sidebar: { background: "#113950", width: 300 },
                        content: {
                            height: '6rem', width: '100%', minWidth: 320, padding: 15,
                            backgroundColor: '#DFDFDF', display: 'flex'
                        }
                    }}
                >
                    <button onClick={() => this.onSetSidebarOpen(true)}>
                        <i className="fa fa-bars" style={{fontSize: '1.8rem'}}></i>
                    </button>
                    <div style={{ width: '100%', marginLeft: 20, display: 'flex', justifyContent: 'center'}}>
                        <img src={LogoHorizontal} alt="Logo" style={{height: '3.5rem'}} />
                    </div>
                </Sidebar>

                <div className="system__content" style={{marginTop: '6rem'}}>
                    {this.props.children}
                </div>

                <Message />
                <ErrorModal
                    isVisible={this.state.visible}
                    title="Sair"
                    text="Você realmente gostaria de sair do sistema?"
                    icon="icon-turn-off"
                    btnCancel={{
                        text: 'Não',
                        onClick: () => this.toggleModal(false)
                    }}
                    btnOk={{
                        text: 'Sim',
                        onClick: () => window.location.replace('#/logout')
                    }}
                />
            </div>
        );
    }
}